import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface SupplierPaymentDto {
    id: string;
    fornecedorId: string;
    fornecedorNome: string;
    status: 'AWAITING_PAYMENT' | 'PAID' | 'EXPIRED' | 'CANCELLED';
    basePrice: number;
    discountAmount: number;
    finalPrice: number;
    couponCode?: string;
    invoiceSlug?: string;
    createdAt: string;
    expiresAt: string;
    paidAt?: string;
    discountType?: 'PERCENTAGE' | 'FIXED';
    discountValue?: number;
    transactionNsu?: string;
    checkoutUrl?: string;
    cancelledAt?: string;
}

export interface PaginatedResult<T> {
    items: T[];
    totalItems: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

@Injectable({
    providedIn: 'root'
})
export class SupplierPaymentService {
    constructor(private api: ApiService) { }

    listarTransacoes(params: {
        page?: number;
        pageSize?: number;
        status?: string;
        orderBy?: string;
        orderDirection?: 'asc' | 'desc';
        fornecedorId?: string;
    } = {}): Observable<PaginatedResult<SupplierPaymentDto>> {
        const p = {
            page: 1,
            pageSize: 20,
            orderBy: 'createdAt',
            orderDirection: 'desc',
            ...params
        };
        return this.api.get('/admin/supplier-payments', p);
    }

    getTransacaoById(id: string): Observable<SupplierPaymentDto> {
        return this.api.get(`/admin/supplier-payments/${id}`);
    }

    getHistoricoFornecedor(fornecedorId: string): Observable<{
        fornecedorId: string;
        totalItems: number;
        items: SupplierPaymentDto[];
    }> {
        return this.api.get(`/admin/fornecedores/${fornecedorId}/payments`);
    }

    confirmarManual(id: string, transactionNsu: string, reason: string): Observable<any> {
        return this.api.post(`/admin/supplier-payments/${id}/confirm`, {
            transactionNsu,
            reason
        });
    }

    cancelar(id: string, reason: string): Observable<any> {
        return this.api.post(`/admin/supplier-payments/${id}/cancel`, { reason });
    }

    expirar(id: string): Observable<any> {
        return this.api.post(`/admin/supplier-payments/${id}/expire`, {});
    }

    expirarTodosVencidos(): Observable<any> {
        return this.api.post('/admin/supplier-payments/expire-all', {});
    }
}
